import { post } from '@core/api/baseApi';
import { AddUserResponse, CustomErroHandlerResponse } from '@core/types';
import { User } from '../../../../core/types/User';

export const addUser = async (payload: Omit<User, 'id'>): Promise<AddUserResponse | CustomErroHandlerResponse> => await post(`/Users`, payload);

